import { useCognitoUserContextWithUser } from 'domains/auth/AWSCognitoWrapper/context';
import { useUserClientsLoggedIn } from 'domains/auth/UserClientsWrapper/useUserClients';
import { getAssociatedClientsAndData, getContact } from 'domains/contact/queries';
import { DEFAULT_QUERY_STALE_TIME } from 'domains/data/staleTime';
import { isString } from 'lodash';
import { useQuery } from 'react-query';

export const useContactAndClients = (config?: { onError: (err: unknown) => void; useErrorBoundary?: boolean }) => {
  const { onError, useErrorBoundary } = config ?? {};
  const { user } = useCognitoUserContextWithUser();

  return useQuery(['contact-data', user.username], () => getAssociatedClientsAndData(user.username), {
    retry: 2,
    useErrorBoundary,
    onError,
    staleTime: DEFAULT_QUERY_STALE_TIME,
  });
};

export const useContact = () => {
  const { contactId } = useUserClientsLoggedIn();

  return useQuery(['contact', contactId], () => getContact(contactId));
};

export const useContactById = ({ contactId, onError }: { contactId?: string; onError?: (err: unknown) => void }) => {
  return useQuery(['contact', contactId ?? ''], () => getContact(contactId as string), {
    enabled: isString(contactId),
    onError,
  });
};
